export default {"src":"/bnb/_next/static/media/kuwallet.c9096503.svg","height":25,"width":25};